export default __webpack_public_path__ + "static/casi-e71d9f21ab4e052adecec2d5ac638895.png";